// The header's search is ONE surface with three modes, so a failure of it is ONE notice: this id
// names the SURFACE and not the mode. That is what keeps a failed phone search and a failed tracking
// search from stacking two copies of the same sentence — only one mode is ever live, and the notice
// does not say which one it was.
//
// It lives at app level rather than inside a slice because `phone-search` and `tracking-search` both
// need it while the edge between them runs one way only (`tracking-search->phone-search`, for
// `detectPhone` — see `scripts/layout-allowed-edges.txt`); the reverse import would close a cycle.
export const HEADER_SEARCH_NOTICE_ID = 'header-search';

// The one sentence for «the read broke», shared by the modes that can break (ADR 0021). Deliberately
// says nothing about the term or the mode: it is a breakdown, and the agent's next move is the same
// in every mode — search again.
//
// The «nothing found» sentence is NOT here even though both modes float that one too, because it is
// the one thing they cannot say identically: the tracking answer has to name the 90-day window it
// searched («…en los últimos 90 días») or the agent reads «does not exist» where the panel means
// «not in the window», and the phone search has no window to name. Each mode keeps its own, next to
// the search it belongs to.
// TODO: i18n
export const SEARCH_FAILED = 'No se pudo completar la búsqueda';
